import { gql, useQuery } from '@apollo/client';

export const GET_HEALTH_INSURANCE_BY_ID = gql`
  query getHealthInsuranceById($id: String!) {
    getHealthInsuranceById(id: $id) {
      _id
      name
      companyId
      createdBy
      healthInsuranceNumbers {
        _id
        healthInsuranceNumber
        clientNumbers
      }
      houseNumber
      street
      city
      zipCode
    }
  }
`;

export const useGetHealthInsuranceById = (id?: string) => {
  const { data, loading } = useQuery(GET_HEALTH_INSURANCE_BY_ID, {
    variables: { id },
    skip: !id,
  });

  const healthInsurance = data?.getHealthInsuranceById || {};

  return { healthInsurance, loading };
};
